'use strict';

class RegistriesController {
  /* @ngInject */
  constructor(RegistriesService, OrderTranslationService, $scope) {
    Object.assign(this, {
      RegistriesService,
      OrderTranslationService,
      $scope
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name DESC'
    };

    this.getModels();

    this.onPagination = () => {
      this.getModels();
    };

    this.onReorder = () => {
      this.getModels();
    };
  }

  getModels() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    let queryReady = this.RegistriesService.getModels(qOpts).then(
      registries => {
        this.registries = registries;
      }
    );
    let countReady = this.RegistriesService.getCount(qOpts).then(result => {
      this.registriesCount = result.count;
    });
    return Promise.all([queryReady, countReady]);
  }
}

export default RegistriesController;
